//---- Code by Wix Monster----
import wixLocation from 'wix-location';
import wixData from 'wix-data';
import { local } from 'wix-storage';

$w.onReady(function () {

    var today = new Date();
    //Set date format
    let day = today.getDate()
    let month = today.getMonth() + 1;
    let year = today.getFullYear()
    let theDate = day + "/" + month + "/" + year;
    //set time
    let hour = today.getHours();
    let min = today.getMinutes();
    let theTime = hour + "" +  min;
    console.log(theTime)

    //-----------------------------------------------------------------------
    ///   הפניה בלתי מותנת לדף החג   
    //  wixLocation.to("/holidays");
    //-----------------------------------------------------------------------	
    ///       בדיקת כניסת שבת
    if (today.getDay() === 5) {
        //find today in database and get time
        wixData.query("ShabatTimes")
            .eq("title", theDate)
            .find()
            .then((results) => {
                console.log(results)
                if (results.items.length > 0) {
                    let time = results.items[0].enterTime;
                //    let time = fulltime.split(':');
                    console.log(time)
                    if (theTime > time) {
                        console.log(time)
                        local.setItem('ID', results.items[0]._id);
                        wixLocation.to("/shabat");
                    } 
                } else {
                    console.log("No date in datatbase")
                }
            })
    }
    ///       בדיקת יציאת שבת
    if (today.getDay() === 6) {
        //find today in database and get time
        wixData.query("ShabatTimes")
            .eq("sahbat", theDate)
            .find()
            .then((results) => {
                if (results.items.length > 0) {
                    let time = results.items[0].exitTime;
                    console.log(time)
                    ///  האתר יפתח בשעה 19:00
                    if (theTime < time) {
                        local.setItem('ID', results.items[0]._id);
                        wixLocation.to("/shabat");
                    }
                } else {
                   console.log("No date in datatbase")
                }
            })

    }
});